﻿<script setup>
    const props = defineProps({
        title: String,
        to: String,
        label: String,
        flat: Boolean,
        dense: Boolean
    });

    const emit = defineEmits(['click']);

    function click() {
        emit('click');
    }
</script>

<template>
    <q-btn 
        :dense="dense"
        :round="!flat"
        :flat="flat"
        :outline="flat"
        :size="flat ? 'md' : 'sm'" 
        color="grey-9" 
        icon="reply" 
        :title="title || 'Cancel'"
        :label="flat ? (label || 'Cancel') : ''"
        @click="click"
        :to="to" />
</template>